import { Injectable } from "@angular/core";
import { Component, Input, ViewChild, ElementRef, Output, EventEmitter } from "@angular/core";
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-alert-message',
	templateUrl: './alert-message.component.html',
	providers: [NgbModalConfig, NgbModal]
})

@Injectable()
export class AlertMessageComponent {
	@Output() successClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() onHide: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Input() title: string;
	@Input() message: string;
    @ViewChild('content', { static: false }) content: ElementRef;

	constructor(config: NgbModalConfig, private modalService: NgbModal) {
		config.backdrop = 'static';
		config.keyboard = false;
	}

	public showMessage(): void {
		this.modalService.open(this.content);
	}
}
